import React, { createContext, useContext, useState, useEffect, useCallback, ReactNode } from 'react';

interface UIContextValue {
	primaryOpen: boolean;
	togglePrimary: () => void;
	setPrimaryOpen: (open: boolean) => void;
}

const UIContext = createContext<UIContextValue | null>(null);

export const useUI = (): UIContextValue => {
	const ctx = useContext(UIContext);
	if (!ctx) throw new Error('useUI must be used within UIProvider');
	return ctx;
};

const LS_PRIMARY_KEY = 'ui_primary_open';

export const UIProvider = ({ children }: { children: ReactNode }) => {
	const [primaryOpen, setPrimaryOpen] = useState(true);

	useEffect(() => {
		try {
			const p = localStorage.getItem(LS_PRIMARY_KEY);
			if (p !== null) setPrimaryOpen(p === 'true');
		} catch (_) {}
	}, []);

	useEffect(() => {
		try {
			localStorage.setItem(LS_PRIMARY_KEY, String(primaryOpen));
		} catch (_) {}
	}, [primaryOpen]);

	const togglePrimary = useCallback(() => setPrimaryOpen((o) => !o), []);

	return (
		<UIContext.Provider value={{ primaryOpen, togglePrimary, setPrimaryOpen }}>
			{children}
		</UIContext.Provider>
	);
};
